import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { AppSettingsService } from "src/app/shared";

@Injectable({
    providedIn: "root",
})
export class AuditTrailService {
    private http = inject(HttpClient);
    private appSettingsService = inject(AppSettingsService);

    private serviceEndpoint: string;

    constructor() {}

    private _dateToString(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return [year, month, day].join("-");
    }

    private _getServiceSettings() {
        if (!this.serviceEndpoint) {
            const appSettings = this.appSettingsService.appSettings;
            this.serviceEndpoint = appSettings["AuditService_URL"] + appSettings["AuditService_Version"] + "audits/";
        }
    }

    getAuditTrail(fromDate: Date, toDate: Date, dashboardId?: string, select?: string) {
        this._getServiceSettings();
        let params = new HttpParams();
        params = params.append("fromDate", this._dateToString(fromDate));
        params = params.append("toDate", this._dateToString(toDate));
        if (dashboardId) {
            params = params.append("dashboardId", dashboardId);
        }
        if (select) {
            params = params.append("select", select);
        }

        return this.http.get<any>(this.serviceEndpoint, {
            params: params,
        });
    }
    getCardAuditTrail(dashboardId: string, cardId: string) {
        this._getServiceSettings();
        return this.http.get<any>(this.serviceEndpoint.replace("/v2", "/v3") + dashboardId + "/" + cardId);
    }
}
